<template>
    <el-dialog :width="config.dialogWidth ? config.dialogWidth : '800px'"
        :custom-class="customClass"
        v-dialogDrag
        :visible.sync="dialogVisible"
        :append-to-body="true"
        @close="dialogClose">
        <div slot="title" class="column-config_title">
            {{dialogTitle}}
        </div>
        <div class="component-container">
            <div class="top-search-group">
                <el-form :inline="true" :model="searchObj">
                    <el-form-item class="search-obj--key">
                        <el-select v-model="searchObj.key" placeholder="请选择">
                            <el-option v-for="option in selectOptions"
                                :key="option.prop"
                                :label="option.value"
                                :value="option.prop"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="search-obj--keyword">
                        <el-input v-model.trim="searchObj.keyword" :placeholder="searchInputPlaceholder" @keyup.enter.native="search" @change="inputChange"></el-input>
                    </el-form-item>
                    <el-form-item v-for="item in moreSearchList" :key="item.prop">
                        <el-input v-if="item.type === 'input'" v-model.trim="moreSearchObj[item.prop]" :placeholder="item.label" @change="val => handleInput(val, item.prop)"></el-input>
                        <m-select v-else-if="item.type === 'select'" :optionNum="item.optionNum" :optionArr="item.optionArr" :placeholder="item.label"
                            @input="data => propsChange(data, item.prop)" size="mini"></m-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search">查询</el-button>
                        <el-button @click="reset">重置</el-button>
                    </el-form-item>
                    </el-form>
                    <el-tooltip v-if="config.configuration" effect="dark" content="列配置" placement="bottom" class="tooltip">
                        <el-button icon="el-icon-setting" size="mini" @click="colDispose"></el-button>
                    </el-tooltip>
            </div>
            <el-row :gutter="20">
                <el-col :span="multiple?16:24">
                    <el-table
                        :data="tableData"
                        highlight-current-row
                        v-loading="loading"
                        height="300"
                        :border="config.border ? config.border : false"
                        @current-change="currentRowChange"
                        @row-dblclick="rowDbClick"
                        @row-click="selectionRow">
                        <el-table-column
                            v-for="column in config.tableConfig"
                            :key="column.prop"
                            :prop="column.prop"
                            :label="column.value"
                            :width="column.width"
                            :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                <template v-if="column.type === 'select'">{{dictFormat(row[column.prop], column.optionsKey,column.options) }}</template>
                                <template v-else>{{row[column.prop]}}</template>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col :span="8" v-if="multiple">
                    <el-table :data="advanceList" class="table-box" height="300" highlight-current-row>
                        <el-table-column :prop="config.multipleTableColumn.prop" :label="config.multipleTableColumn.value"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="60">
                            <template slot-scope="scope">
                                <el-button class="deleteBtn" @click="deleteDate(scope.$index)" size="small" type='text'>删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <div class="config-footer">
                <el-row>
                    <el-col v-if="mode !== 'EbPlace'" :span="3" style="line-height:30px;">共&nbsp;&nbsp;{{pageTotal}}&nbsp;&nbsp;项</el-col>
                    <el-col v-if="mode !== 'EbPlace'" :span="16">
                        <el-pagination
                            background
                            class="table-pagination"
                            :layout="pageSizes.length ? 'prev, pager, next, sizes' : 'prev, pager, next'"
                            :current-page.sync="page.pageNo"
                            :page-size="page.pageSize"
                            :page-sizes="pageSizes"
                            :total="pageTotal"
                            @size-change="sizeChange"
                            @current-change="currentChange">
                        </el-pagination>
                    </el-col>
                    <el-col :offset="mode === 'EbPlace' ? 19 : 0" :span="5" style="text-align: right;">
                        <el-button type="text" @click="dialogVisible = false;">取消</el-button>
                        <el-button type="primary" @click="confirm" :disabled="disabledCancel">确定</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>

        <el-dialog v-if="config.configuration" :append-to-body="true" :visible.sync="showModal" title="列配置">
            <configuration
            v-if="showModal"
                :checkedList="checkedList"
                :selectAllColumns="selectAllColumns"
                ref="dialog"
                @getTableConfigList="getTableConfigList"
                @tableConfigClose="tableConfigClose"
                :columnNum="columnNum"
            ></configuration>
        </el-dialog>
    </el-dialog>
</template>
<script>
import { getList } from '../../api/annoMana.js';
import configuration from '@/components/otpPanel/configuration-list';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import request from '@/utils/http';
import { dictWithUrl } from '@/components/lots/api';
import mSelect from '@/components/lots/otpSelect2/index';
// import { filterSpecChar } from '../utils';
export default {
    props: {
        pageSizes: {
            type: Array,
            default(){
                return []
            }
        },
        disabledDbClick: {
            type: Boolean,
            default: false
        },
        rejectClose: {
            type: Boolean,
            default: false
        },
        defaultValue: {
            type: String,
            default() {
                return '';
            }
        },
        mCode: [String, Number],
        mValue: [String, Number],
        mValueList: {
            type: Array,
            default() {
                return [];
            }
        },
        max: { // 可选最大条数, 为 0 时表示不限制
            type: Number,
            default() {
                return 0;
            }
        },
        customClass: {
            type: String,
            default() {
                return '';
            }
        }
    },
    components: { mSelect, configuration },
    computed: {
        ...mapGetters(['currentTenant']),
        selectOptions() {
            return this.config.advanceConfig || this.config.tableConfig;
        },
        dialogTitle() {
            return this.config.advanceLabel || this.config.name || this.config.label;
        },
        moreSearchList() {
            return this.config.moreSearchList || [];
        },
        searchInputPlaceholder() {
            let placeholder = '请输入'
            if (this.searchObj.key) {
                const option = this.selectOptions.find(item => item.prop === this.searchObj.key)
                placeholder = option && option.placeholder ? option.placeholder : placeholder
            }
            return placeholder
        },
    },
    data() {
        return {
            columnNum: 100,
            showModal: false,
            checkedList: '',
            selectAllColumns: [],
            disabledCancel: false,
            dialogVisible: false,
            requestMethod: 'get',
            loading: false,
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            searchObj: {},
            moreSearchObj: {}, // 更多查询条件的输入值
            tableData: [],
            config: {},
            multiple: false,
            multipleDelConfirm: false,
            advanceList: [], // 已选数据
            mode: ''
        };
    },
    created() {
    },
    watch: {
        dialogVisible(val) {
            if (!val) {
                this.disabledCancel = false;
            }
        }
    },
    methods: {
        setConfigColumn(config) {
            const pramas = {
                moduleCode: this.config.configuration.moduleCode,
                subjectType: this.config.configuration.subjectType,
            };
            getList.get(pramas).then(res => {
                if (res.data && res.data.configNameCn) {
                    //有设置过列配置
                    const datas = res.data.configNameCn.split(',');
                    const columnsList = [];
                    datas.map(title => {
                        this.selectAllColumns.map(data => {
                            if (data.label === title) {
                                columnsList.push(data);
                            }
                        });
                    });
                    this.config.tableConfig = columnsList
                    const arr = [];
                    this.config.tableConfig.forEach(el => {
                        arr.push(el.label);
                    });
                    this.checkedList = arr.join(',');
                }else{
                    //首次配置列配置,如果有设置defaultLabel就用defaultLabel，否则取整个列字段
                    this.getTableConfigList(config.configuration.defaultLabel || config.tableConfig.map(v => v.label||v.value)+'', config.configuration.defaultProp || config.tableConfig.map(v => v.prop)+'')
                }
            });
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            this.showModal = false;
            const pramas = {
                configName: tabelConfigName,
                configNameCn: tabelConfigList,
                moduleCode: this.config.configuration.moduleCode,
                subjectType: this.config.configuration.subjectType,
            };
            getList.post(pramas).then(() => {});
            const datas = tabelConfigList.split(',');
            const columnsList = [];
            datas.map(title => {
                this.selectAllColumns.map(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.config.tableConfig = []
            this.$nextTick(() => {
                this.config.tableConfig = columnsList
            })
            const arr = [];
            columnsList.forEach(el => {
                arr.push(el.label||el.value);
            });
            this.checkedList = arr.join(',');
        },
        colDispose() {
            this.showModal = true;
        },
        tableConfigClose() {
            this.showModal = false;
        },
        async fetchData() {
            this.loading = true;
            let params = {};
            // 对关键字的[]{}符号进行转义
            const keyword = this.requestMethod === 'get' ? this.searchObj.keyword.replace(/{/g, '%7b').replace(/}/g, '%7d').replace(/\[/g, '%5b').replace(/\]/g, '%5d') : this.searchObj.keyword;
            if (this.searchObj.key === 'ALL') {
                params = { ...this.advanceCascade, ...this.page };
                for (let i = 1; i < this.selectOptions.length; i++) {
                    params[this.selectOptions[i].prop] = keyword;
                }
            } else {
                params = { ...this.advanceCascade, ...this.page, [this.searchObj.key]: keyword };
            }
            params = { ...params, ...this.moreSearchObj };
            const reqConfig = {
                method: this.requestMethod,
                url: `${this.prefix}${this.config.advanceUrl}`
            };
            if (this.requestMethod === 'get') {
                reqConfig.params = params;
            } else {
                reqConfig.data = params;
            }
            if (this.hasTenant) {
                reqConfig.headers = { ...reqConfig.headers, tenantCode: this.currentTenant.tenantCode };
            }
            const res = await request(reqConfig).catch(() => { this.loading = false; });
            if (res && res.code === '0') {
                if (res.data.totalPage !== 0 && this.page.pageNo > res.data.totalPage) {
                    this.page.pageNo = res.data.totalPage;
                    this.fetchData();
                } else {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
                if (this.mode === 'EbPlace') { // 处理地区选择时的格式情况
                    this.tableData = res.data;
                }
            } else {
                this.tableData = [];
            }
            this.loading = false;
        },
        async show(status = true, config, advanceCascade = {}, mode = '') {
            this.requestMethod = config.method || 'get';
            this.prefix = config.prefix || '/api-mdm/';
            this.hasTenant = config.hasTenant || false;
            this.dialogVisible = status;
            this.multiple = config.multiple ? config.multiple : false;
            this.multipleDelConfirm = config.multipleDelConfirm || false;
            if (status === false) return;
            if (!config) {
                this.$message.error('弹窗配置对象为空！');
                return;
            }
            if (this.multiple) {
                this.advanceList = [];
            }
            this.mode = mode;
            if(config.configuration){
                //有列配置
                this.config = {...config, tableConfig: []};
                this.selectAllColumns = JSON.parse(JSON.stringify(config.tableConfig.map(v => ({...v, label: v.value}))))
                this.setConfigColumn(config)
            }else{
                this.config = config;
            }
            this.$set(this.searchObj, 'key', this.selectOptions[0].prop);
            this.$set(this.searchObj, 'keyword', '');
            this.moreSearchList.forEach(item => {
                this.$set(this.moreSearchObj, item.prop, '');
            });
            if (this.defaultValue) {
                this.$set(this.searchObj, 'keyword', this.defaultValue);
            }
            this.advanceCascade = advanceCascade;
            // 过滤出是否有字典转义列
            const selectKeyCols = _.chain(this.config.tableConfig).filter(obj => obj.optionsKey).value();
            // 存在需字典转义列就请求字典
            if (selectKeyCols.length) {
                const optionsKeys = selectKeyCols.map(item => item.optionsKey).join(',')
                this.loading = true
                const dictRes = await dictWithUrl(optionsKeys).catch(err => {});
                this.loading = false
                if (!dictRes || +dictRes.code !== 0) {
                    return false
                }
                selectKeyCols.forEach(item => {
                    this.$set(item, 'options', dictRes.data[item.optionsKey] || {});
                });
            }
            // notFetchOnShow 判断是否弹窗显示时就请求数据
            if (!config.notFetchOnShow) {
                this.fetchData();
            }
            // 打开弹窗时显示已选数据
            this.setSelectedRows();
        },
        dictFormat(val, optionsKey, options) {
            if (options) {
                return _.get(options, val, val);
            } else {
                return val;
            }
        },
        sizeChange(v){
            this.page.pageSize = v
            this.fetchData();
        },
        // 页码变化
        currentChange(val) {
            if (this.config.queryConditionRequired && !this.searchObj.keyword) {
                this.$message.warning('查询条件不能为空!');
                return false;
            }
            this.page.pageNo = val;
            this.fetchData();
        },
        // 搜索
        search() {
            if (this.config.queryConditionRequired && !this.searchObj.keyword) {
                this.$message.warning('查询条件不能为空!');
                return false;
            }
            this.page.pageNo = 1;
            this.fetchData();
        },
        // 重置
        reset() {
            this.searchObj.keyword = '';
            this.advanceList = [];
            this.moreSearchList.forEach(item => {
                this.$set(this.moreSearchObj, item.prop, '');
            });
            if (this.config.queryConditionRequired) {
                this.clear();
            } else {
                this.fetchData();
            }
        },
        // 重置数据
        clear() {
            this.page.pageNo = 1;
            this.tableData = [];
            this.pageTotal = 0;
        },
        // 表格
        currentRowChange(row) {
            this.currentRow = row;
        },
        // 表格双击
        rowDbClick(row) {
            if (this.disabledDbClick) return false;
            if (this.multiple && this.max && this.advanceList.length >= this.max) {
                this.$message.warning(`选择数据不能超过${this.max}个!`);
                return false;
            }
            this._emitResult(row);
        },
        confirm() {
            if ((!this.multiple && !this.currentRow) || (this.multiple && !this.advanceList.length)) {
                this.$message.warning('没选中数据');
                return;
            }
            this._emitResult(this.currentRow);
        },
        // 返回选中值
        _emitResult(row) {
            const data = {};
            if (!this.config.cbParams) {
                this.$message.error('弹窗没定义cbParams配置!');
                return;
            }
            if (this.multiple) {
                const searchData = {};
                if (!row) {
                    row = {};
                }
                this.config.tableConfig.forEach(item => {
                    searchData[item.prop] = [];
                    this.advanceList.map(aitem => {
                        searchData[item.prop].push(aitem[item.prop]);
                    });
                    row[item.prop] = searchData[item.prop].join(',');
                    // 以 xxxArray 属性值返回数组格式
                    row[item.prop + 'Array'] = searchData[item.prop];
                });
                if (this.config.tableExtraProps) {
                    this.config.tableExtraProps.forEach(prop => {
                        searchData[prop] = [];
                        this.advanceList.map(aitem => {
                            searchData[prop].push(aitem[prop]);
                        });
                        row[prop] = searchData[prop].join(',');
                    });
                }
            }
            for (const item of this.config.cbParams) {
                let { 0: sourceProp, 1: destProp } = item.split('#');
                destProp = destProp || sourceProp;
                data[destProp] = row[sourceProp];
            }
            this.$emit('confirm', data, this.config);
            if (this.rejectClose) {
                this.disabledCancel = true;
                return false;
            }
            this.dialogVisible = false;
        },
        inputChange(val) { },
        dialogClose() {
            // 重置属性
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.pageTotal = 0;
            this.searchObj = {};
            this.tableData = [];
        },
        deleteDate(index) {
            if (this.multipleDelConfirm) {
                const name = this.advanceList[index][this.config.multipleTableColumn.prop];
                this.$confirm(`请确认是否删除 ${name}?`, '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.advanceList.splice(index, 1);
                }).catch(() => {});
            } else {
                this.advanceList.splice(index, 1);
            }
        },
        selectionRow(currentRow) {
            if (this.multiple) {
                let num = 0;
                this.advanceList.map(item => {
                    if (item[this.config.tableConfig[0].prop] === currentRow[this.config.tableConfig[0].prop]) {
                        num += 1;
                    }
                });
                if (num === 0) {
                    if (this.max && this.advanceList.length >= this.max) {
                        this.$message.warning(`选择数据不能超过${this.max}个!`);
                        return false;
                    }
                    this.advanceList.push(currentRow);
                }
            } else {
                this.advanceList = currentRow;
            }
        },
        setSelectedRows() {
            // 处理数据的回显
            if (this.multiple) {
                if (!this.mCode) {
                    this.advanceList = [];
                    return;
                }
                const mCode = this.mCode.split(',');
                // 如果 mValueList 有值就用 mValueList 的值回显，没有就用 mValue 分隔后的值
                const values = this.mValueList.length ? this.mValueList : this.mValue.split(',');
                const arr = mCode.map((el, i) => {
                    return {
                        [this.config.tableConfig[0].prop]: el,
                        [this.config.tableConfig[1].prop]: values[i]
                    };
                });
                this.advanceList = arr;
            }
        },
        handleInput(val, prop) {
            this.moreSearchObj[prop] = val;
        },
        propsChange(val, prop) {
            this.moreSearchObj[prop] = val;
        }
    }
};

</script>

<style lang="less">
.column-config_title{
    small{
        margin-left: 25px;
    }
}

.component-container {
    .top-search-group{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .config-footer {
        margin-top: 18px;
    }

    .table-pagination{
        float: left;
        padding: 0;

        .btn-prev, .btn-next, .el-pager li {
            background-color: #fff !important;
            border: 1px solid #ccc;
            border-radius: 4px !important;
        }

        .el-pager li.active + li {
            border-left: 1px solid #ccc;
        }

        .el-pager li:not(.disabled).active{
            background-color: #00BCBF !important;
            border: 1px solid #00BCBF;
        }
    }

    .el-form-item {
        margin-bottom: 0;
    }
}
</style>